import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { initGtm } from './gtm'

import VueDaumPostcode from 'vue-daum-postcode'
import { setupDeepLink } from '@/utils/deeplink'

import "@/assets/css/default.css"
import "@/assets/css/quill.snow.css"
import "@/assets/css/common.css"
import "@vueform/toggle/themes/default.css"
import "@/assets/css/style.css"

// GTM 클라이언트 정보는 컨테이너가 첫 태그를 쏘기 전에 올려야 한다.
initGtm()

// 문자 딥링크 진입(네이티브 브릿지 + 인증 가드). mount 전에 걸어야 최초 진입도 가드를 탄다.
// GTM 뒤에 둔다 — 이 가드가 곧바로 화면을 옮길 수 있어 그전에 클라이언트 정보가 올라가 있어야 한다.
setupDeepLink(router, store)

const app = createApp(App)
app.use(store).use(router).use(VueDaumPostcode)
app.mount('#app')
